/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Quota configuration
 * @export
 * @interface StorageQuota
 */
export interface StorageQuota {
    /**
     * 
     * @type {string}
     * @memberof StorageQuota
     */
    tenantId?: string;
    /**
     * 
     * @type {number}
     * @memberof StorageQuota
     */
    totalStorageQuotaBytes?: number;
    /**
     * 
     * @type {number}
     * @memberof StorageQuota
     */
    databaseStorageQuotaBytes?: number;
    /**
     * 
     * @type {number}
     * @memberof StorageQuota
     */
    blobStorageQuotaBytes?: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof StorageQuota
     */
    perEntityTypeQuotaBytes?: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof StorageQuota
     */
    warningThresholdPercent?: number;
    /**
     * 
     * @type {number}
     * @memberof StorageQuota
     */
    criticalThresholdPercent?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StorageQuota
     */
    enforcementEnabled?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof StorageQuota
     */
    alertRecipients?: Array<string>;
}

/**
 * Check if a given object implements the StorageQuota interface.
 */
export function instanceOfStorageQuota(value: object): value is StorageQuota {
    return true;
}

export function StorageQuotaFromJSON(json: any): StorageQuota {
    return StorageQuotaFromJSONTyped(json, false);
}

export function StorageQuotaFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorageQuota {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'totalStorageQuotaBytes': json['totalStorageQuotaBytes'] == null ? undefined : json['totalStorageQuotaBytes'],
        'databaseStorageQuotaBytes': json['databaseStorageQuotaBytes'] == null ? undefined : json['databaseStorageQuotaBytes'],
        'blobStorageQuotaBytes': json['blobStorageQuotaBytes'] == null ? undefined : json['blobStorageQuotaBytes'],
        'perEntityTypeQuotaBytes': json['perEntityTypeQuotaBytes'] == null ? undefined : json['perEntityTypeQuotaBytes'],
        'warningThresholdPercent': json['warningThresholdPercent'] == null ? undefined : json['warningThresholdPercent'],
        'criticalThresholdPercent': json['criticalThresholdPercent'] == null ? undefined : json['criticalThresholdPercent'],
        'enforcementEnabled': json['enforcementEnabled'] == null ? undefined : json['enforcementEnabled'],
        'alertRecipients': json['alertRecipients'] == null ? undefined : json['alertRecipients'],
    };
}

export function StorageQuotaToJSON(json: any): StorageQuota {
    return StorageQuotaToJSONTyped(json, false);
}

export function StorageQuotaToJSONTyped(value?: StorageQuota | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'totalStorageQuotaBytes': value['totalStorageQuotaBytes'],
        'databaseStorageQuotaBytes': value['databaseStorageQuotaBytes'],
        'blobStorageQuotaBytes': value['blobStorageQuotaBytes'],
        'perEntityTypeQuotaBytes': value['perEntityTypeQuotaBytes'],
        'warningThresholdPercent': value['warningThresholdPercent'],
        'criticalThresholdPercent': value['criticalThresholdPercent'],
        'enforcementEnabled': value['enforcementEnabled'],
        'alertRecipients': value['alertRecipients'],
    };
}

